import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Columns, Config, DefaultConfig, API, APIDefinition } from 'ngx-easy-table';
import { IntranetoldService } from './../../../api/intranetold.service'
import { StockComercialDetalleItemBodegaComponent } from './detalleArticuloBodega';
import { variableGlobal } from "../../../global.enum";
import Swal from 'sweetalert2'
import { ExportToCsv } from 'export-to-csv';
import { DetalleItemComponent } from './detalleItem';
import { DetalleItemService } from 'src/app/api/detalleItem.service';
import { StockComercialDPedidoInternoComponent } from './detalleArticuloPedidoInterno';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { string } from '@amcharts/amcharts4/core';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-stock-comercial',
  templateUrl: './stock-comercial.component.html',
  styleUrls: ['./stock-comercial.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StockComercialComponent implements OnInit {

  constructor(
    private _api: IntranetoldService,
    private modalService: NgbModal,
    private _detalleItemService: DetalleItemService,
    private _dbService: NgxIndexedDBService,
    private cdr: ChangeDetectorRef

  ) { }

  @ViewChild('table', { static: true }) table: APIDefinition;
  data: any = [];
  dataCopia: any = [];
  OPLN: any;
  listaPrecio: number = 1;
  listaCategorias: any;
  categoriaSeleccionada: string = "";
  listaFamilia: any;
  familiaSeleccionada: string = "";
  listaSubFamilia: any;
  subFamiliaSeleccionada: string = "";
  public configuration: Config;
  public columns: Columns[];
  usuario: any = { ADMIN: false };
  // scanner state
  showScanner = false;
  scannerError: string | null = null;
  private mediaStream: MediaStream | null = null;
  private barcodeDetector: any;
  @ViewChild('video') videoRef!: ElementRef<HTMLVideoElement>;
  // enhanced scanner controls
  devices: MediaDeviceInfo[] = [];
  selectedDeviceId: string | null = null;
  canFlip = false;
  torchOn = false;
  torchSupported = false;
  private videoTrack: MediaStreamTrack | null = null;
  manualCode: string = '';
  highlightItemCode: string | null = null;

  async ngOnInit(): Promise<void> {
    // 1) Cargar la tabla inmediatamente, sin depender del login en IndexedDB
    await this.cargaTabla();

    // 2) Cargar detalles en segundo plano para marcar tieneDetalle
    setTimeout(async () => {
      try {
        const itemsConDetalles: any[] = await this.obtieneListaMaterialVirtual();
        if (itemsConDetalles && itemsConDetalles.length && this.data && this.data.length) {
          const codeSet = new Set(itemsConDetalles.map((e: any) => e.Code));
          for (const it of this.data) {
            if (codeSet.has(it.ItemCode)) {
              it.tieneDetalle = true;
            }
          }
          this.cdr.markForCheck();
        }
      } catch {}
    }, 0);

    // 3) Obtener login en paralelo; si cambia a ADMIN, actualizamos columnas
    this._dbService.getByID(variableGlobal.DB_TABLE_GENERAL, variableGlobal.DB_TABLE_GENERAL_id_login).subscribe(item => {
      const itemx: any = item;
      const nuevoUsuario = itemx?.datos?.login || {};
      const eraAdmin = !!this.usuario?.ADMIN;
      this.usuario = nuevoUsuario;
      const esAdmin = !!this.usuario?.ADMIN;

        this.columns = [
          { key: 'ItemCode', title: "Codigo", cellTemplate: this.frmItemCode },
          { key: 'ItemName', title: 'Descripción' },
          { key: 'ItmsGrpNam', title: 'Categoria' },
          { key: 'FirmName', title: 'Marca' },
          { key: '', title: 'Disponible para venta', cssClass: { includeHeader: true, name: 'green-background' }, cellTemplate: this.frmDisponibleVenta },
          { key: 'Available', title: 'Disponible' },
          { key: 'OnHand', title: 'En stock' },
          { key: 'IsCommited', title: 'NV' },
          { key: 'Price', title: 'Precio', cellTemplate: this.frmPrice },
        ];
      
      this.cdr.markForCheck();
      
    });
  }



  @ViewChild('frmItemCode', { static: true }) frmItemCode: TemplateRef<any>;
  @ViewChild('frmDisponibleVenta', { static: true }) frmDisponibleVenta: TemplateRef<any>;
  @ViewChild('frmSTOCK_PEDIDO_INTERNO', { static: true }) frmSTOCK_PEDIDO_INTERNO: TemplateRef<any>;
  @ViewChild('frmPrice', { static: true }) frmPrice: TemplateRef<any>;
  @ViewChild('frmDisponible', { static: true }) frmDisponible: TemplateRef<any>;
  // SE muestra este mensaje durante mucho tiempo, solucionar
  async cargaTabla() {
    Swal.fire({
      title: 'Espere por favor!',
      html: 'Se esta cargando stock',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });

    

    this.columns = [
      { key: 'ItemCode', title: "Codigo", cellTemplate: this.frmItemCode },
      { key: 'ItemName', title: 'Descripción' },
      { key: 'ItmsGrpNam', title: 'Categoria' },
      { key: 'FirmName', title: 'Marca' },
      { key: '', title: 'Disponible para venta', cssClass: { includeHeader: true, name: 'green-background' }, cellTemplate: this.frmDisponibleVenta },
      { key: 'Available', title: 'Disponible' },
      { key: 'OnHand', title: 'En stock' },
      { key: 'IsCommited', title: 'NV' },
      { key: 'OnOrder', title: 'Por llegar' },
      { key: 'STOCK_PEDIDO_INTERNO', title: 'Stock Pedido Interno', cellTemplate: this.frmSTOCK_PEDIDO_INTERNO },
      { key: 'Disponible_TW', title: 'Disponible TW' },
      { key: 'Price', title: 'Precio', cellTemplate: this.frmPrice },
      { key: 'FACTOR_VENTA', title: 'Factor / Venta' }
    ];
    
    


    this.configuration = {
      ...DefaultConfig,
      searchEnabled: true,
      detailsTemplate: true,
      paginationRangeEnabled: false,

      horizontalScroll: true,
      resizeColumn: false,
      fixedColumnWidth: true,
    };

    var data: any = await this._api.getQueryAll();
    var query: string = "";

    await data.objeto.forEach(element => {
      // if (element.NOMBRE == "stockComercial") {
      if (element.NOMBRE == "stockComercialCLP") { //stockComercial
        query = element.CONSULTA;
      }
    });

    this.data = await this._api.GetNotFileQuery(query);
    this.dataCopia = this.data.objeto;

  // console.debug('stockComercialCLP query loaded', { total: this.dataCopia?.length });
    await data.objeto.forEach(element => {
      if (element.NOMBRE == "listaPrecios") {
        query = element.CONSULTA;
      }
    });
    var datos: any = await this._api.GetNotFileQuery(query);
    this.OPLN = datos.objeto;

  // console.debug('listaPrecios loaded', { total: this.OPLN?.length });

    let collator = new Intl.Collator()

    var distinct = this.dataCopia
      .map(item => item.ItmsGrpNam)
      .filter((value, index, self) => self.indexOf(value) === index);
    distinct = distinct.sort((a, b) => collator.compare(a, b));
    // distinct = distinct.sort((a,b) => a.localeCompare(b));
    this.listaCategorias = distinct;

    distinct = this.dataCopia
      .map(item => item.U_IND_CATEGORIA2)
      .filter((value, index, self) => self.indexOf(value) === index);
    distinct = distinct.sort((a, b) => collator.compare(a, b));
    // distinct = distinct.sort((a,b) => a.localeCompare(b));
    this.listaFamilia = distinct;
    distinct = this.dataCopia
      .map(item => item.U_IND_CATEGORIA3)
      .filter((value, index, self) => self.indexOf(value) === index);

    distinct = distinct.sort((a, b) => collator.compare(a, b));
    // distinct = distinct.sort((a,b) => a.localeCompare(b)); //error posible acá
    this.listaSubFamilia = distinct;

    this.data = [...this.dataCopia];


    if (variableGlobal.ESTILO_EASY_TABLE) {
      this.setClass(variableGlobal.ESTILO_EASY_TABLE);
    }

    Swal.close();
  }

  private setClass(name: string): void {
    this.table.apiEvent({
      type: API.setTableClass,
      value: name,
    });
  }

  AbrirDetalleItem(item) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };
    const modalRef = this.modalService.open(StockComercialDetalleItemBodegaComponent, ngbModalOptions);
    modalRef.componentInstance.ItemCode = item.ItemCode;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.result.then((data) => {


    }, (reason) => {
      //this.editar(item);
    });
  }

  AbrirDetalleItemPedidoInterno(item) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      modalDialogClass: variableGlobal.CLASS_MODAL_BG
    };
    const modalRef = this.modalService.open(StockComercialDPedidoInternoComponent, ngbModalOptions);
    modalRef.componentInstance.ItemCode = item.ItemCode;
    modalRef.componentInstance.modalReference = modalRef;
    modalRef.result.then((data) => {


    }, (reason) => {
      //this.editar(item);
    });
  }

  limpiar() {
    this.data = [...this.dataCopia];
    //this.listaPrecio = 1;
    this.categoriaSeleccionada = "";
    this.familiaSeleccionada = "";
    this.subFamiliaSeleccionada = "";
  }

  filtro() {
    this.data = [...this.dataCopia];
    //ItmsGrpNam              categoriaSeleccionada
    //U_IND_CATEGORIA2        familiaSeleccionada
    //U_IND_CATEGORIA3        subFamiliaSeleccionada
    if (this.categoriaSeleccionada) {
      this.data = this.data.filter((_) => _.ItmsGrpNam == this.categoriaSeleccionada);
    }
    if (this.familiaSeleccionada) {
      this.data = this.data.filter((_) => _.U_IND_CATEGORIA2 == this.familiaSeleccionada);
    }
    if (this.subFamiliaSeleccionada) {
      this.data = this.data.filter((_) => _.U_IND_CATEGORIA3 == this.subFamiliaSeleccionada);
    }
  }

  async cambiaPrecio() {
    Swal.fire({
      title: 'Espere por favor!',
      html: 'Se esta cargando lista de precio',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    var data: any = await this._api.getQueryAll();
    var query: string = "";
    await data.objeto.forEach(element => {
      if (element.NOMBRE == "stockComercialCLP") { //stockComercial
        query = element.CONSULTA;
      }
    });
    query = query.replace("[PriceList] = 1", "[PriceList] = " + this.listaPrecio);
    
    var datos: any = await this._api.GetNotFileQuery(query);
    this.data = datos.objeto;
    this.dataCopia = [...this.data];
    this.filtro();
    Swal.close();

  }

  async exportToXLSX(): Promise<void> {
    var data: any = await this._api.getQueryAll();
    var query: string = "";
  
    await data.objeto.forEach(element => {
      if (element.NOMBRE == "stockComercialCLPPorBodegaV2") {
        query = element.CONSULTA;
      }
    });
  
    let stringItemCodes = "";
  
    this.data.forEach(element => {
      if (stringItemCodes == "") {
        stringItemCodes = stringItemCodes + "'" + element.ItemCode + "'";
      } else {
        stringItemCodes = stringItemCodes + ",'" + element.ItemCode + "'";
      }
    });
  
    query = query.replace('REEMPLAZAITEMCODES', stringItemCodes);
  
    let dataCSV: any = await this._api.GetNotFileQuery(query);
  
    const headersMapping: { [key: string]: string } = {
      "ItemCode": "Código de artículo",
      "ItemName": "Nombre del artículo",
      "U_IND_TIPO": "Tipo",
      "ItmsGrpNam": "Grupo de artículos",
      "U_IND_CATEGORIA2": "Categoría 2",
      "U_IND_CATEGORIA3": "Categoría 3",
      "WhsCode": "Código de bodega",
      "WhsName": "Nombre de la bodega",
      "OnHand": "Stock disponible",
      "IsCommited": "Comprometido",
      "OnOrder": "En orden",
      "Available": "Disponible",
      "Price": "Precio",
      "U_IND_SWW": "Código interno",
      "Currency": "Moneda",
      "FirmName": "Proveedor",
      "U_IND_Factor2": "Factor 2",
      "U_IND_CATEGORIA21": "Categoría 21",
      "U_IND_CATEGORIA31": "Categoría 31",
      "U_IND_SWW1": "Código interno 1",
      "STOCK_PEDIDO_INTERNO": "Stock pedido interno",
      "Disponible_TW": "Disponible TW"
    };
  
    // Función para mapear los títulos.
    function mapHeaders(obj: any): any {
      const mappedObj: any = {};
      Object.keys(obj).forEach(key => {
        mappedObj[headersMapping[key] || key] = obj[key];
      });
      return mappedObj;
    }
  
    const dataForExport = dataCSV.objeto.map(mapHeaders);
  
    // Crear una hoja de cálculo (worksheet)
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataForExport);
  
    // Definir estilos de encabezados simplificados
    const headerStyle = {
      fill: {
        fgColor: { rgb: "FF0000" } // Rojo de fondo para prueba
      },
      font: {
        color: { rgb: "FFFFFF" }, // Blanco
        bold: true,
        sz: 14 // Tamaño de la fuente
      }
    };
  
    // Establecer el rango para los encabezados
    const headerRange = XLSX.utils.decode_range(ws['!ref']!);
  
    for (let col = headerRange.s.c; col <= headerRange.e.c; col++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
      if (ws[cellAddress]) {
        ws[cellAddress].s = headerStyle; // Aplicar estilo a la celda
      }
    }
  
    // Crear el archivo de Excel
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Reporte Artículos');
  
    // Aplicar ajuste de ancho automático a las columnas
    const wscols = Object.keys(headersMapping).map(() => ({ wpx: 120 })); // Ancho predeterminado de las columnas
    ws['!cols'] = wscols;
  
    // Guardar el archivo XLSX
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'reporte_articulos.xlsx');
  }
  
  

  abrirListaItem(item) {
    this._detalleItemService.abrirDetalleItem(item);
  }

  async obtieneListaMaterialVirtual() {

    let objetoApi = []

    let res: any = await this._detalleItemService.obtieneListaMaterialVirtual(objetoApi);

    return res.resultado;

  }

  bodyHTML:any = "";

  agregarHeader(){
    this.bodyHTML += '<div class="header">asd</div>'
  }

  // --- Escáner de código de barras ---
  async openScanner() {
    this.scannerError = null;
    this.showScanner = true;
    this.torchOn = false;
    this.torchSupported = false;
    this.selectedDeviceId = this.selectedDeviceId || null;
    await Promise.resolve();

    const anyWindow = window as any;
    if ('BarcodeDetector' in window) {
      try {
        const formats = ['code_128', 'ean_13', 'ean_8', 'code_39', 'upc_a', 'upc_e', 'itf'];
        this.barcodeDetector = new anyWindow.BarcodeDetector({ formats });
      } catch (e) {
        try { this.barcodeDetector = new anyWindow.BarcodeDetector(); } catch {}
      }
    }

    try {
      await this.startStream();
      await this.loadDevices();
    } catch (err) {
      this.scannerError = 'No se pudo acceder a la cámara. Verifique los permisos del navegador.';
      return;
    }

    if (this.barcodeDetector) {
      this.scanFrame();
    } else {
      this.scannerError = 'El navegador no soporta escaneo nativo. Ingrese el código manualmente.';
    }
  }

  private async startStream() {
    // Stop previous
    this.stopStream();
    const videoConstraints: MediaTrackConstraints = this.selectedDeviceId
      ? { deviceId: { exact: this.selectedDeviceId } as any }
      : { facingMode: { ideal: 'environment' } as any };
    this.mediaStream = await navigator.mediaDevices.getUserMedia({ video: videoConstraints, audio: false });
    const video = this.videoRef?.nativeElement;
    if (video) {
      video.srcObject = this.mediaStream as any;
      await video.play();
    }
    // Track and capabilities
    this.videoTrack = this.mediaStream.getVideoTracks()[0] || null;
    const caps = (this.videoTrack as any)?.getCapabilities?.() || {};
    this.torchSupported = !!caps.torch;
    this.canFlip = (this.devices?.length || 0) > 1;
    this.cdr.markForCheck();
  }

  private async loadDevices() {
    try {
      const all = await navigator.mediaDevices.enumerateDevices();
      this.devices = all.filter(d => d.kind === 'videoinput');
      this.canFlip = this.devices.length > 1;
      // If nothing selected, prefer a back/environment camera if labels available
      if (!this.selectedDeviceId && this.devices.length) {
        const back = this.devices.find(d => /back|trás|environment/i.test(d.label));
        this.selectedDeviceId = (back || this.devices[0]).deviceId;
      }
      this.cdr.markForCheck();
    } catch { /* ignore */ }
  }

  private async scanFrame() {
    if (!this.showScanner || !this.barcodeDetector) return;
    const video = this.videoRef?.nativeElement;
    if (video && video.readyState >= 2) {
      try {
        const barcodes = await this.barcodeDetector.detect(video);
        if (barcodes && barcodes.length) {
          const code = barcodes[0].rawValue || barcodes[0].displayValue || '';
          if (code) {
            this.onBarcodeDetected(code);
            return;
          }
        }
      } catch (e) {}
    }
    setTimeout(() => this.scanFrame(), 200);
  }

  private onBarcodeDetected(code: string) {
    // Filtrar por ItemCode (igual o contiene)
    this.data = this.dataCopia.filter((row: any) => {
      const itemCode = (row.ItemCode || '').toString();
      return itemCode === code || itemCode.includes(code);
    });
    this.highlightItemCode = this.data?.[0]?.ItemCode || null;
    this.closeScanner();
    // esperar render y hacer scroll
    setTimeout(() => {
      if (this.highlightItemCode) {
        const el = document.getElementById('item-' + this.highlightItemCode);
        el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 0);
  }

  onCameraChange(event: Event) {
    const select = event.target as HTMLSelectElement;
    this.selectedDeviceId = select.value || null;
    this.startStream();
  }

  async flipCamera() {
    if (!this.canFlip || !this.devices.length) return;
    const idx = this.devices.findIndex(d => d.deviceId === this.selectedDeviceId);
    const next = this.devices[(idx + 1) % this.devices.length];
    this.selectedDeviceId = next?.deviceId || null;
    await this.startStream();
  }

  async toggleTorch() {
    if (!this.videoTrack) return;
    try {
      // toggle
      this.torchOn = !this.torchOn;
      const supported = (this.videoTrack as any)?.getCapabilities?.()?.torch;
      if (supported) {
        await (this.videoTrack as any).applyConstraints({ advanced: [{ torch: this.torchOn }] });
      }
    } catch {
      this.torchSupported = false;
      this.torchOn = false;
    } finally {
      this.cdr.markForCheck();
    }
  }

  applyManualCode() {
    const code = (this.manualCode || '').trim();
    if (!code) return;
    this.onBarcodeDetected(code);
    this.manualCode = '';
  }

  closeScanner() {
    this.showScanner = false;
    this.scannerError = null;
    try {
      const video = this.videoRef?.nativeElement;
      if (video) {
        video.pause();
        video.srcObject = null;
      }
    } catch {}
    this.stopStream();
  }

  private stopStream() {
    try {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(t => t.stop());
      }
    } finally {
      this.mediaStream = null;
      this.videoTrack = null;
      this.torchOn = false;
    }
  }

  ngOnDestroy(): void {
    this.stopStream();
  }

}
